var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5001,
    cy: 46.5,
    r: 46.5,
    fill: "#4987FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5002 29.5C67.0211 29.5 69.8752 32.3542 69.8752 35.875V57.125C69.8752 60.6459 67.0211 63.5 63.5002 63.5H29.5002C25.9794 63.5 23.1252 60.6459 23.1252 57.125V35.875C23.1252 32.3542 25.9794 29.5 29.5002 29.5H63.5002ZM61.9126 33.75H31.0879L45.1835 44.878C45.9555 45.4876 47.0448 45.4876 47.817 44.878L61.9126 33.75ZM27.3752 36.2337V57.125C27.3752 58.2986 28.3266 59.25 29.5002 59.25H63.5002C64.6738 59.25 65.6252 58.2986 65.6252 57.125V36.2337L50.4503 48.2138C48.1343 50.0424 44.8661 50.0424 42.55 48.2138L27.3752 36.2337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMsg);
export default __webpack_public_path__ + "static/media/Contact_msg.32963da9ee18b6901cc4f861bcdfe316.svg";
export { ForwardRef as ReactComponent };